const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/rbac/resource.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ResListFilterParamSchema } from '@apps/main/features/admin/pages/rbac/res-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/rbac/resource')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: search => ResListFilterParamSchema.parse(search)
});